import { Phone } from "lucide-react";
import logo from "@/assets/oz-move-logo.webp";

const footerLinks = {
  Services: [
    { label: "Home Moves", href: "/home-moves" },
    { label: "Apartment Moves", href: "/apartment-moves" },
    { label: "Office Relocations", href: "/office-relocations" },
    { label: "Single Item Moves", href: "/single-item-moves" },
    { label: "Same Day Moves", href: "/same-day-moves" },
  ],
  Locations: [
    { label: "Melbourne", href: "/melbourne" },
    { label: "Sydney", href: "/sydney" },
    { label: "Brisbane", href: "/brisbane" },
    { label: "Perth", href: "/perth" },
    { label: "Adelaide", href: "/adelaide" },
    { label: "Gold Coast", href: "/gold-coast" },
  ],
  Company: [
    { label: "How It Works", href: "#how-it-works" },
    { label: "Reviews", href: "#reviews" },
    { label: "Get a Quote", href: "#quote" },
    { label: "Why Choose Us", href: "#comparison" },
    { label: "Contact Us", href: "/contact" },
  ],
  Legal: [
    { label: "Privacy Policy", href: "/privacy-policy" },
    { label: "Terms & Conditions", href: "/terms-conditions" },
  ],
};

const Footer = () => (
  <footer className="bg-[#111111] pt-14 pb-8">
    <div className="container">
      {/* Top row - logo, tagline, phone */}
      <div className="mb-10">
        <img src={logo} alt="OZ MOVE CO." className="h-28 md:h-32 w-auto mb-3" width="384" height="256" />
        <p className="text-[#FFC300] font-bold text-base">Fast. Reliable. Done Right.</p>
        <p className="text-white/60 text-xs mt-1.5">Fully insured&nbsp;•&nbsp;Fast response</p>

        <div className="mt-5">
          <p className="text-white/65 text-[11px] uppercase tracking-wider font-semibold mb-1.5">Call us</p>
          <a
            href="tel:1800556654"
          data-call-source="footer"
            className="flex items-center gap-2 text-[#FFC300] font-bold text-xl hover:opacity-80 transition-opacity w-fit"
          >
            <Phone className="w-5 h-5" />
            1800 556 654
          </a>
        </div>
      </div>

      {/* Link columns */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 mb-10">
        {Object.entries(footerLinks).map(([heading, links]) => (
          <div key={heading}>
            <p className="font-bold text-white text-sm mb-3.5">{heading}</p>
            <ul className="space-y-2">
              {links.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-white/45 text-sm hover:text-white/70 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Divider + copyright */}
      <div className="border-t border-white/10" />
      <div className="pt-5 text-white/60 text-xs text-center">
        © {new Date().getFullYear()} OZ MOVE CO. All rights reserved.
      </div>
    </div>
  </footer>
);

export default Footer;
